import { call, put, select, takeLatest } from 'redux-saga/effects';

import API from 'services/api';
import paymentService from 'services/paymentService';

import * as SESSION from 'store/session';
import { fetchProfile } from 'store/session/actions';

import {
  types,
  createStripeAccount,
  getOnBoardingLink,
  updateCreditCardCheckout,
} from './actions';

export default function* root() {
  yield takeLatest(
    types.CREATE_STRIPE_ACCOUNT_REQUEST,
    watchRequestCreateStripeAccount,
  );
  yield takeLatest(
    types.GET_STRIPE_ONBOARDING_LINK_REQUEST,
    watchRequestGetStripeOnboardingLink,
  );
  yield takeLatest(
    types.UPDATE_CREDIT_CARD_CHECKOUT_REQUEST,
    watchRequestUpdateCreditCardCheckout,
  );
}

function* watchRequestCreateStripeAccount() {
  try {
    const groupId = yield select(SESSION.selectors.getGroupId);
    yield call(paymentService.createStripeAccount, groupId);
    yield put(getOnBoardingLink.request());
    yield put(createStripeAccount.success());
  } catch (error) {
    yield put(createStripeAccount.error(error));
  }
}

function* watchRequestGetStripeOnboardingLink() {
  try {
    const groupId = yield select(SESSION.selectors.getGroupId);
    const { url } = yield call(paymentService.getStripeOnboardingLink, groupId);
    window.location.replace(url);
    yield put(getOnBoardingLink.success());
  } catch (error) {
    yield put(getOnBoardingLink.error());
  }
}

function* watchRequestUpdateCreditCardCheckout(action) {
  const { creditCardCheckout } = action.payload;
  try {
    const groupId = yield select(SESSION.selectors.getGroupId);
    yield call(API.groups.updateUserGroup, groupId, {
      creditCardCheckout,
    });
    // reload the users profile to include updated tax rate
    yield put(fetchProfile.request(action.payload));
    yield put(updateCreditCardCheckout.success(action.payload));
  } catch (e) {
    console.error(e);
    yield put(updateCreditCardCheckout.error(action.payload));
  }
}
